/**
 * auth — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/auth.ts`.
 */

export const auth = {
  /* ---------------- auth ---------------- */
  'auth.signin': 'Anmelden',
  'auth.register': 'Konto anlegen',
  'auth.email': 'E-Mail',
  'auth.password': 'Passwort',
  'auth.password.hint': '(mindestens 10 Zeichen)',
  'auth.name': 'Name (optional)',
  'auth.busy': 'einen Moment …',
  'auth.toRegister': 'Neu hier? Konto anlegen',
  'auth.toLogin': 'Schon ein Konto? Anmelden',

  /* the one place the product says what it is */
  'auth.tagline': 'VFR-Flugplanung für Europa. Karte, NavLog, Wetter, Gelände — und das LBA-Formblatt.',
} as const;
